import React from "react";
import { useIntl } from "react-intl";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, notification } from "antd";
import * as S from "./styled";
interface LoadingProps {
  show: boolean;
  children?: any;
}

interface ErrorNotificationProps {
  message: string;
}

const Loading = ({ show, children }: LoadingProps) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const intl = useIntl();

  if (show) {
    return (
      <S.Container>
        <Spin indicator={antIcon} tip={intl.formatMessage({ id: "loading" })} size="large" />
      </S.Container>
    );
  } else {
    return children;
  }
};

export const showErrorNotification = ({ message }: ErrorNotificationProps) => {
  notification.error({
    message: "Oops!",
    description: message,
    placement: "bottomRight",
    duration: 3,
  });
};

Loading.defaultProps = {
  show: true,
};

export default Loading;
